module.exports = __webpack_public_path__ + "common/icon-single-color-2b455ab4c11f93ac3148062d14079fbd.svg";